module.exports = __webpack_public_path__ + "static/media/locker.9102e39e.webp";